import { Component, Event, EventEmitter, h, Prop } from "@stencil/core";
import { navStateStore } from "@phn/state/nav-state-store";
import { navContentStore } from "@phn/state/nav-content-store";
import { MenuItemVariant } from "@phn/utility/constants";
import { isShopAvailable } from "@phn/utility/helper/shop-helper";
import { goTo } from "../../services/routing-manager";
import { getLevel1Items } from "../../services/menu-items-service";
import { isDesktop } from "@phn/utility/helper";

@Component({
  tag: "phn-nd-level-1",
  styleUrl: "level-1.scss",
  scoped: true,
})
export class Level1 {
  @Prop() locale!: string;

  @Prop() breakpoint!: number;

  @Event({ bubbles: true }) mobileMenuItemClick!: EventEmitter<string[]>;

  private showRightIconRight(
    iconRight: string | undefined,
  ): string | undefined {
    const { app } = navStateStore.state;
    const { shop } = navContentStore.state;
    const isOneUiMobileShop =
      isShopAvailable(shop, this.locale, app) && !isDesktop(this.breakpoint);

    if (iconRight !== undefined && isOneUiMobileShop) {
      iconRight = "arrow-head-right";
    }
    return iconRight;
  }

  render(): HTMLPhnNdLevel1Element {
    const { loggedInState, unreadMessagesCount, userConsent } =
      navStateStore.state;

    // in some unfortunate cases, the userConsent is a boolean due to an outdated state file from the navigation package
    // we assume that an update of the navigation package will fix this issue but need to keep this workaround
    const consentStatus =
      typeof userConsent === "boolean"
        ? userConsent
        : !!userConsent?.googleMaps;

    const level1Items = getLevel1Items(
      navContentStore.state,
      this.locale,
      loggedInState,
      unreadMessagesCount,
      consentStatus,
    );

    return (
      <div>
        {level1Items.map(
          ({
            routingKeys,
            elementId,
            iconRight,
            showIconModifier,
            ...level1Item
          }) => (
            <phn-nd-menu-item
              key={elementId}
              elementId={elementId}
              onClick={() => {
                if (level1Item.link === undefined) {
                  goTo(...routingKeys);
                }
              }}
              iconRight={
                iconRight !== undefined
                  ? this.showRightIconRight(iconRight)
                  : "arrow-head-right"
              }
              variant={MenuItemVariant.Level1}
              {...level1Item}
            >
              {showIconModifier ? (
                <span
                  slot="icon-modifier"
                  aria-hidden="true"
                  class="account-unread-messages-indicator"
                  data-test-id="unread-messages-indicator"
                />
              ) : null}
            </phn-nd-menu-item>
          ),
        )}
      </div>
    ) as HTMLPhnNdLevel1Element;
  }
}
